import React from "react";
import { connect } from "react-redux";
import { pdt } from "hf-rt";
import "../../../css/PdtInfo.css";
import { Translation } from "react-i18next";

class PdtInfo extends React.Component {
  render() {
    const { info, img, code } = this.props;
    return (
      <table className="pdtDetails_table">
        <tbody className="pdtDetails_table_tbody">
          <tr className="pdtDetails_table_tbody_tr">
            <td className="pdtThm_col">
              <img className="pdtThm" src={img} alt="" />
            </td>
            <td>
              {pdt.stringToHtml(info.description)}
              <p className="styleNo" >
                <Translation>
                  {t => <>{t("pdtInfo.styleNumber")}</>}
                </Translation>
                # {code}
              </p>
              <ul className="ul-bullet ul-bullet-black">
                {info.information.map(item => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}
const mapStateToProps = state => {
  return {
    img: state.product.productBookingUnit.media.sizingImage,
    code: state.product.product.code
  };
};
export default connect(mapStateToProps)(PdtInfo);
